/* eslint-disable react/require-default-props */
import React from 'react';

import './TextButton.scss';
import classNames from 'classnames';

export type TextButtonType = 'button' | 'submit' | 'reset' | 'file';

export interface ITextButton {
  icon?: string;
  outlineIcon?: boolean;
  href?: string;
  disabled?: boolean;
  errorStyling?: boolean;
  onClick: (e?: React.MouseEvent<HTMLElement>) => void;
  children: React.ReactNode;
}

const TextButton = React.forwardRef<
  HTMLAnchorElement | HTMLSpanElement | HTMLButtonElement,
  ITextButton
>(({ icon, href, outlineIcon, disabled, errorStyling, onClick, children, ...props }, ref) => {
  const BaseComponent = href ? 'a' : 'button';
  const otherProps: any = {
    ...props,
    href,
    role: href ? 'button' : undefined,
    type: href ? undefined : 'button',
  };

  let clickHandler = disabled ? undefined : (e) => onClick(e);

  // Need this otherwise the 'a' tag will still be clickable when disabled
  if (href && disabled) {
    clickHandler = (e) => e.preventDefault();
  }

  return (
    <BaseComponent
      className={classNames('TextButton', { error: errorStyling, disabled })}
      ref={ref}
      {...otherProps}
      onClick={clickHandler}
    >
      {icon ? (
        <i className={classNames('material-icons', { 'material-icons-outlined': outlineIcon })}>
          {icon}
        </i>
      ) : undefined}
      {children}
    </BaseComponent>
  );
});

export default TextButton;
